import gql from 'graphql-tag';

export const CartShippingEntryFragment = gql`
  fragment CartShippingEntryFragment on cartSettings_GlobalSet {
    shippingEntry {
      ...LinkFragment
    }
  }
`;

export const CartDealsSettingsFragment = gql`
  fragment CartDealsSettingsFragment on cartSettings_GlobalSet {
    showIcon
    useAlternativeStyle
  }
`;

export const DeliveryDetailsSettingsFragment = gql`
  fragment DeliveryDetailsSettingsFragment on cartSettings_GlobalSet {
    deliveryDetails {
      ... on deliveryDetailsBlock_Entry {
        id
        label
        hasTooltip
        tooltipContent
        valueDefault
        valueWithFreeShipping
      }
    }
  }
`;

export const HighDemandProductsSettingsFragment = gql`
  fragment HighDemandProductsSettingsFragment on cartSettings_GlobalSet {
    cartHighDemandMessage
    productHandles {
      ... on productHandlesBlock_Entry {
        productHandle
      }
    }
  }
`;

export const useCartSettingsStore = defineStore('cartSettings', {
  state: () => ({
    paymentMethods: null,
    notificationActive: false,
    notificationFontColor: null,
    notificationBackgroundColor: null,
    notificationHeading: null,
    notificationBody: null,
    shippingEntry: null,
    cartDealSettings: {},
    deliveryDetails: [],
    cartHighDemandMessage: false,
    highDemandProducts: [],
  }),

  getters: {
    shippingEntryUri: (state) => state.shippingEntry?.element?.uri || null,
    hasPaypalMethod: (state) => {
      if (!state.paymentMethods) return false;

      return state.paymentMethods.includes('paypal');
    },
  },

  actions: {
    init(payload) {
      const {
        notificationActive,
        notificationFontColor,
        notificationBackgroundColor,
        notificationHeading,
        notificationBody,
        paymentMethods,
        shippingEntry,
        cartHighDemandMessage,
        productHandles,
      } = payload;

      this.notificationActive = notificationActive;
      this.notificationFontColor = notificationFontColor;
      this.notificationBackgroundColor = notificationBackgroundColor;
      this.notificationHeading = notificationHeading;
      this.notificationBody = notificationBody;
      this.paymentMethods = paymentMethods.paymentMethods;
      this.shippingEntry = shippingEntry;
      this.cartHighDemandMessage = cartHighDemandMessage;
      this.highDemandProducts = productHandles.map((product) => product.productHandle);
    },

    initCartDeals(payload) {
      this.cartDealSettings = {
        showIcon: payload.showIcon,
        useAlternativeStyle: payload.useAlternativeStyle,
      };

      this.deliveryDetails = payload.deliveryDetails;
    },
  },
});
